import { Loader } from '@/modules/base/classes/loaders'
import { Result } from '@/modules/errorHandling/results'
import { KeyDict } from '@/types'

export class Ordway {
  entities: KeyDict<string>
  customers: KeyDict<KeyDict<KeyDict<string>>>

  constructor (data: unknown) {
    this.entities = Loader.loadAndCast(data, 'entities', {})
    this.customers = Loader.loadAndCast(data, 'customers', {})
  }

  static load (data: unknown): Result<Ordway, 'invalid_params'|'unknown'> {
    try {
      return Result.success(new Ordway(data))
    } catch (error) {
      return Result.fromUnknownError('invalid_params', error)
    }
  }
}
